<app-loader></app-loader>
<div class="login-sec">
    <p-image src="assets/images/login-truck.png" alt="Image" width="200" class="img-truck"></p-image>
    <div class="common-password-outer login-left col-12 lg:col-6">
        <div class="logo-sec">
            <p-image class="custom-logo" src="assets/images/logo-white.svg" alt="Image"></p-image>
            <h1 class="evolution-text">The Evolution</h1>
            <p class="evolution-text common-margin-bottom">of Parking Tracking</p>
        </div>
    </div>
    <div class="login-right col-12 lg:col-6">
        <form class="change-form" [formGroup]="resetPasswordForm">
            <h3>Change Password</h3>
            <div class="email-outer">

                <div class="custom-flex-start bottom-space formgrid">
                    <label for="oldPassword">Current Password <span class="custom-star">*</span></label>
                    <p-password class="small-placeholder" indicator="false" [toggleMask]="true" [feedback]=false
                        id="oldPassword" placeholder="Enter Current Password" maxlength="15"
                        (keydown)="onPasswordKeyDown($event, 'oldPassword')" formControlName="oldPassword"></p-password>
                    <div class="error-outer">
                        <small
                            *ngIf="resetPasswordForm.get('oldPassword').hasError('required') && (resetPasswordForm.get('oldPassword').dirty || resetPasswordForm.get('oldPassword').touched)"
                            class="validation-error">This field is required*</small>
                        <small
                            *ngIf="resetPasswordForm.get('oldPassword').hasError('minlength') && (resetPasswordForm.get('oldPassword').touched || resetPasswordForm.get('oldPassword').dirty)"
                            class="validation-error">Minimum 3 characters are required*</small>
                        <small
                            *ngIf="resetPasswordForm.get('oldPassword').hasError('maxlength') && (resetPasswordForm.get('oldPassword').touched || resetPasswordForm.get('oldPassword').dirty)"
                            class="validation-error">Maximum 15 characters are required*</small>
                    </div>
                </div>
                <div class="custom-flex-start bottom-space formgrid">
                    <label for="newPassword">New Password <span class="custom-star">*</span></label>
                    <p-password class="small-placeholder" indicator="false" [toggleMask]="true" [feedback]=false
                        id="newPassword" placeholder="Enter New Password" maxlength="15"
                        (keydown)="onPasswordKeyDown($event, 'newPassword')" formControlName="newPassword"></p-password>
                    <div class="email-outer">
                        <div
                            *ngIf="resetPasswordForm.get('newPassword').invalid && (resetPasswordForm.get('newPassword').dirty || resetPasswordForm.get('newPassword').touched)">
                            <small *ngIf="resetPasswordForm.get('newPassword').hasError('required')"
                                class="validation-error">Password is required.</small>
                            <small *ngIf="resetPasswordForm.get('newPassword').hasError('invalidPassword')"
                                class="validation-error">
                                Length must be 8-15 with uppercase, lowercase, number & special characters.
                            </small>
                        </div>
                    </div>
                </div>

                <div class="custom-flex-start bottom-space formgrid">
                    <label for="confirmPassword">Confirm Password <span class="custom-star">*</span></label>
                    <p-password class="small-placeholder" indicator="false" [toggleMask]="true" [feedback]=false
                        id="confirmPassword" placeholder="Enter Confirm Password" maxlength="15"
                        (keydown)="onPasswordKeyDown($event, 'confirmPassword')"
                        formControlName="confirmPassword"></p-password>
                    <div class="error-outer">
                        <div
                            *ngIf="resetPasswordForm.get('confirmPassword').invalid && (resetPasswordForm.get('confirmPassword').dirty || resetPasswordForm.get('confirmPassword').touched)">
                            <small *ngIf="resetPasswordForm.get('confirmPassword').hasError('required')"
                                class="validation-error">Password is required.</small>
                            <small *ngIf="resetPasswordForm.get('confirmPassword').hasError('invalidPassword')"
                                class="validation-error">
                                Length must be 8-15 with uppercase, lowercase, number & special characters.
                            </small>
                        </div>
                        <div *ngIf="!resetPasswordForm.get('confirmPassword').hasError('invalidPassword')">
                            <small class="text-center validation-error"
                                *ngIf="resetPasswordForm.hasError('passwordMismatch')">Confirm Password should match the
                                Password</small>
                        </div>

                    </div>

                </div>
                <div class="custom-flex-start gap-2">
                    <p-button label="Save Password" (onClick)="resetPassword(resetPasswordForm.value)"></p-button>
                </div>

            </div>
        </form>
    </div>